import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../Store";
import CallButtonModel from "../../CallButtonModel";
import ETAcomponent from "./ETAcomponent";

const InfoContainerVolvia = () => {
  const { casesStore } = useStore();
  const { t, i18n } = useTranslation();
  const event = casesStore.latestEvent;

  if (!event) {
    return <div id="info-container"><CallButtonModel noEvent /></div>;
  }

  return (
    <div id="info-container-volvia">
      <div id="info-container-info-volvia">
        <div className="info-container-info-block">
          <div className="info-container-contact-info">
            <div className={`info-container-photo-container-${casesStore.brand}-${i18n.language}`}>
              <div className="info-container-contact-info-ETA-volvia" />
              <div className={`info-container-product-text-${i18n.language}`} />
            </div>
            <div className="info-container-contact-info-ETA-volvia">
              {t("ETA")}
              <ETAcomponent />
            </div>
            <div className="clear-both" />
          </div>
        </div>
        <CallButtonModel />
      </div>
    </div>
  );
};

export default observer(InfoContainerVolvia);
